import { render, staticRenderFns } from "./SelectObjectives.vue?vue&type=template&id=47c2e490"
import script from "./SelectObjectives.vue?vue&type=script&lang=js"
export * from "./SelectObjectives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports